import DelegationContainer from './delegation-section-container'
export default DelegationContainer
